// src/api/puppiesApi.js
import { db, storage } from "../firebase";
import {
  collection,
  addDoc,
  getDocs,
  getDoc,
  updateDoc,
  deleteDoc,
  doc,
  query,
  where,
  orderBy,
  serverTimestamp,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
const COL = "puppies";

// For admin: show everything
export async function listAllPuppies() {
  const q = query(collection(db, COL), orderBy("createdAt", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

// List public puppies for the site
export async function listPublicPuppies() {
  const q = query(
    collection(db, COL),
    where("public", "==", true),
    orderBy("order", "asc")
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

// Get single puppy by id
export async function getPuppy(id) {
  const s = await getDoc(doc(db, COL, id));
  if (!s.exists()) return null;
  return { id: s.id, ...s.data() };
}

// Add new puppy
// data can include name, status, public, price, etc.
// file is optional. If provided, it will be uploaded and imageUrl set
export async function addPuppy({ data, file }) {
  let imageUrl = data.imageUrl || "";
  if (file) {
    const imgRef = ref(storage, `puppies/${Date.now()}_${file.name}`);
    await uploadBytes(imgRef, file);
    imageUrl = await getDownloadURL(imgRef);
  }

  const payload = {
    ...data,
    imageUrl,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  };

  const docRef = await addDoc(collection(db, COL), payload);
  return docRef.id;
}

// Update an existing puppy
export async function updatePuppy(id, patch) {
  await updateDoc(doc(db, COL, id), { ...patch, updatedAt: serverTimestamp() });
}

// Delete a puppy and optional image in Storage
export async function deletePuppy(id, imageUrl) {
  await deleteDoc(doc(db, COL, id));
  if (imageUrl) {
    try {
      const url = new URL(imageUrl);
      // decode the full path after /o/
      const path = decodeURIComponent(url.pathname.split("/o/")[1]);
      const fileRef = ref(storage, path);
      await deleteObject(fileRef);
    } catch (e) {
      console.warn("Could not delete image from storage:", e);
    }
  }
}
